// Pass as :map-keydown to <v-select>. While the dropdown is open, Escape only closes the
// dropdown instead of also bubbling up to document listeners (e.g. a slideout closing on Escape).
export function keepEscapeInsideOpenSelect(map, vm) {
    return {
        ...map,
        27: (e) => {
            if (vm.dropdownOpen) {
                e.stopPropagation();
            }

            return map[27](e);
        },
    };
}
